export const JSON_Bank_Ifcs14 = {
    "code":"0x0200",
    "message":"Record fetched successfully.",
    "status":"SUCCESS",
    "data":{
        "requestId":"VPAN28335017105332100010"
    }
};

export const JSON_Bank_Ifcs15 = {
    "code":"0x0202",
    "status":"FAILURE",
    "message":"Insufficient funds"
}